/*eslint-disable strict */
import "./polyfills";
import "./misc/errorReporting/bootstrapErrorReporting";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './app';
import Config from './config';
import Analytics from './analytics';
import TranslatesProvider from "./translatesProvider";
import ErrorBoundary from "./misc/errorReporting/ErrorBoundary";
import {instrumentReduxStore} from "./misc/errorReporting/errorReporter";
require('es6-promise').polyfill();

instrumentReduxStore(store);
Analytics.sendEvent('Bathroom-Visualizer-Loaded');
window.resetMixpanelId = () => Analytics.logOutMixPanel();
// window.t1 = performance.now();

ReactDOM.render(
  <Provider store={store}>
    <TranslatesProvider>
      <ErrorBoundary>
        <App/>
      </ErrorBoundary>
    </TranslatesProvider>
  </Provider>,
  document.getElementById('app')
);

window.resetKiosk = function () {
  if (parent && document.kvConfig.kioskMode) {
    if (parent.window.resetKiosk) {
      Config.parent.window.resetKiosk();
    }
  }
};
